import { duration } from 'moment';
import { AuthorizerGenerator } from 'pusher-js';
import { BatchAuthorizer } from './batch-authorizer';

const authorizers: Record<string, BatchAuthorizer> = {};

export const authorizer =
  (delay = duration(0, 'seconds')): AuthorizerGenerator =>
  (channel) => ({
    authorize: (socketId, callback) => {
      authorizers[socketId] =
        authorizers[socketId] ?? new BatchAuthorizer(socketId, delay);
      authorizers[socketId].add(channel.name, callback);
    },
  });
